<template>
  <a-card class="ViewRecord">
    <a-form-model layout="inline">
      <a-form-model-item label="选择题目">
        <a-select allowClear v-model="search.topicId" placeholder="请选择题目" style="width: 250px">
          <a-select-option v-for="item in selectList" :key="item.id" :value="item.id">
            {{ item.topic }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="评价均分">
        <a-input-group compact>
          <a-input-number style="width: 100px; text-align: center" placeholder="最低分" type="number" :precision="2" :min="0" :max="5" v-model="search.minScore" />
          <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
          <a-input-number style="width: 100px; text-align: center; border-left: none" placeholder="最高分" :precision="2" :min="search.minScore" :max="5" type="number" v-model="search.maxScore" />
        </a-input-group>
      </a-form-model-item>
      <a-form-model-item label="评价时间">
        <a-range-picker
          v-model="times"
          @change="changeRange"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="getList(1)">查询</a-button>
      </a-form-model-item>
    </a-form-model>
    <div class="table">
      <a-table :columns="columns" :scroll="{ y: 350 }" rowKey="id" @change="handleTableChange" :pagination="table.tablePagination" :loading="table.tableLoading" :dataSource="table.tableDataSource">
        <div slot="evaluationRate" slot-scope="text">{{ text.evaluationRate }}%</div>
        <div slot="topic" slot-scope="text">{{ text.topic }}</div>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import moment from 'moment'
const columns = [
  { title: '题目', scopedSlots: { customRender: 'topic' } },
  { title: '评价均分', sorter: true, dataIndex: 'evaluateScore' },
  { title: '评价次数', sorter: true, dataIndex: 'evaluateCount' },
  { title: '评价率', sorter: true, scopedSlots: { customRender: 'evaluationRate' } },
]
export default {
  name: 'ViewRecord',
  data() {
    return {
      times: [],
      record: JSON.parse(localStorage.getItem('commentRecord')),
      moment,
      search: {
        topicId: undefined,
        minScore: undefined,
        maxScore: undefined,
      },
      columns,
      table: tableRelevant.call(this),
      selectList: [],
    }
  },
  mounted() {
    if (this.$route.query.startTime) {
      this.search.startTime = this.$route.query.startTime
      this.search.endTime = this.$route.query.endTime
	  this.times = [moment(this.search.startTime ),moment(this.search.endTime )]
    }
    this.setTitle()
    this.getList(1)
    this.getAllTopic()
  },
  methods: {
    changeRange(e = []) {
      if (e.length === 0) {
        this.search.startTime = undefined
        this.search.endTime = undefined
      } else {
        this.search.startTime = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
        this.search.endTime = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    setTitle() {
      let tabName = this.record.versionName ? this.record.contentName + ' - ' + this.record.versionName : this.record.contentName
      const arr = ['首页', '内容中心', { name: '游戏评价', path: '/content/GamesComment' }, { name: '评价记录', path: '/content/GamesComment?activekey=1' }, tabName]
      $Bus.$emit('pageHeaderBreadcrumb', arr)
      $Bus.$emit('pageHeaderTitle', tabName)
      $Bus.$emit('updateTabName', { path: this.$route.path, name: '查看记录' })
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(sorter.order)
      this.table.tableLoading = true
      setTimeout(() => {
        this.table.tableLoading = false
      }, 500)
    },
    getAllTopic() {
      let params = {
        contentId: this.$route.query.contentId,
      }
      this.$http.GamesComment.getAllTopic(params).then((res) => {
        const { status, data, message } = res
          this.selectList = data
      })
    },
    getList(pageIndex) {
      let params = {
        contentId: this.$route.query.contentId,
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        ...this.search,
      }
      this.table.tableLoading = true
      this.$http.GamesComment.getViewEvaluateSummaryList(params).then((res) => {
        const { status, data, message } = res
          this.table.tableDataSource = data.items
          this.table.tablePagination.total = data.totalCount
          this.table.tablePagination.current = data.pageIndex
        
      }).finally(() => {
        this.table.tableLoading = false
      })
    },
  },
}
</script>

<style scoped>
.table {
  margin-top: 15px;
}
a {
  text-decoration: underline;
}
</style>
